//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

// #region Imports

import { Dictionary } from '../../../helpers/'
import { CommonHelper } from '../../../helpers/common-helper'
import { ConfigHelper } from '../../../helpers/config-helper'
import { ConvertHelper } from '../../../helpers/convert-helper'
import { EventsNames } from '../../../helpers/events-names'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { LogHelper } from '../../../helpers/log-helper'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { TemplateHelper } from '../../../helpers/template-helper'
import { ToastHelper } from '../../../helpers/toast-helper'
import { TypeHelper } from '../../../helpers/type-helper'
import { Activity } from '../../../models/common/activity'
import { Enums } from '../../../models/common/enums'
import { OpDataTypeGroup, OpDataType, OpDescr } from '../../../models/core'
import { OpDataTypeInGroup } from '../../../models/core/op-data-type-in-group'
import { UserSessionService } from '../../../services/user-session'
import { ColumnModel, DescrModel } from '../../api/api.models'
import { LocalDictionaryFactory } from '../../api/api.module'
import { Details, DetailsAccordion, DetailsAccordionSection, DetailsScope } from '../../common/common.details'
import { GridBridge } from '../../common/common.interfaces'
import { LoggerService } from '../../common/common.module'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { DetailsOptions, DetailsPopupOptions } from '../../common/details-popup/details-popup.directive'
import { GridController, GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { OperatorLayoutSetting } from '../../../models/local'
import { DataTypeGroupService } from '../../../services/data-type-group'
import { DescrType } from '../../common/select-add-descr/select-add-descr.directive'
import { IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs, IMRConfirmationPopupOptions } from '../../../modules/common/confirmation-popup2'
import { IReferenceType } from '../../../models/util/interfaces'
import { BackwardCompatibilityHelper } from '../../../helpers/backward-compatibility-helper'
import { DataProviderRequest } from '../../../data-provider'


// #endregion

// #region ILocationDetailsScope

interface IDataTypeGroupDetailsScope
    extends DetailsScope {
    // #region Template consts

    DATA_TYPE_GROUP_COMMON_TAB_NAME: string
    DATA_TYPE_GROUP_PARAMS_ACCORDION_NAME: string
    DATA_TYPE_IN_GROUP_PARAMS_ACCORDION_NAME: string
    NO_ACTIVE_ACCORDIONS_NAME: string

    // #endregion

    // #region Popup

    id: number
    editId: number
    popupFor: any
    popupTitle: string

    // #endregion

    // #region DataTypeGroup options

    detailsParametersOptions: DetailsParametersOptions
    dataTypeInGroupGridOptions: GridOptions
    isDataTypeInGridLoading: boolean
    dataTypesInGroupGridEditOptions: GridBridge
    currentDescription: OpDescr
    newCustomDescr: OpDescr

    // #endregion

    // #region Other

    onCustomDescrChanged(elementId: number, propertyName: string, descr: DescrModel): void

    confirmationPopupOptions: IMRConfirmationPopupOptions

    // #endregion
}

// #endregion

export class DataTypeGroupDetailsDirectiveController
    extends Details<IDataTypeGroupDetailsScope>
{
    // #region Consts   

    private static get DefaultAccordionName(): string { return 'common' }
    private get NO_ACTIVE_ACCORDIONS_NAME(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoActiveAccordions) }
    private get DATA_TYPE_IN_GROP_EDIT_POPUP_ID(): string { return `DATA_TYPE_IN_GROP_EDIT_POPUP_ID` }
    private get DATA_TYPE_IN_GROP_GRID_EDIT_NAME(): string { return 'DATA_TYPE_IN_GROP_GRID_EDIT_NAME' }

    // #endregion

    // #region Members

    private getDataTypeGroupRequest: DataProviderRequest<OpDataTypeGroup> = null
    private referenceObject: OpDataTypeGroup
    private referenceObjectId: number

    private dataTypesInGroup: OpDataTypeInGroup[]
    private dataTypesInGroupGrid: GridController<OpDataTypeInGroup>

    private confirmationPopup: IIMRConfirmationPopup

    // #endregion

    // #region Ctor

    constructor(
        protected $scope: IDataTypeGroupDetailsScope,
        protected $timeout: ng.ITimeoutService,
        protected $q: ng.IQService,
        private $compile: ng.ICompileService,
        protected logger: LoggerService,
        protected localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        private dataTypeGroupService: DataTypeGroupService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName,

    ) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.LocationPopupTabActive, userSession, referenceType)

        this.$scope.editId = $scope.$id

        this.setLocalizationText()
        this.setEvents()
        this.setOptions()
        this.setConfirmationPopup()
        this.setTemplateConsts()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    // #endregion

    // #region Events

    private onOpen(options: DetailsOptions): void {
        this.$scope.detailsOpenParams = options
        this.$scope.popupFor = CommonHelper.location
        this.accordionsNameToShow = DataTypeGroupDetailsDirectiveController.DefaultAccordionName

        this.referenceObjectId = options.referenceObjectId

        this.$scope.isEditingConfigurationProfile = false
        this.$scope.isConfigurationProfileLoaderVisible = false

        this.onClear()
        this.onRefresh()
        this.showPopup()
    }

    private onRefresh(toRefresh: OpDataTypeGroup = null): void {
        this.$scope.options.isDataLoaded = false

        const deferred: JQueryDeferred<OpDataTypeGroup> = $.Deferred<OpDataTypeGroup>()
        this.$scope.isDataTypeInGridLoading = true

        if (toRefresh == null) {
            this.getDataTypeGroupRequest = this.userSession
                .getDataProvider()
                .DataTypeGroup
                .getDataTypeGroup(this.referenceObjectId)

            this.getDataTypeGroupRequest
                .then((result: OpDataTypeGroup) => {
                    this.$scope.popupTitle = result.toString()
                    deferred.resolve(result)
                })
                .fail((error: any) => {
                    const errorMsg: string = ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator)
                    ToastHelper.showError(errorMsg)

                    deferred.resolve(null)
                })
                .always(() => {
                    this.$scope.showTabs = true
                })
        } else {
            deferred.resolve(toRefresh)
        }

        deferred
            .promise()
            .then((result: OpDataTypeGroup) => {
                if (result != null && (this.referenceObject == null || this.referenceObject.idDataTypeGroup == result.idDataTypeGroup)) {
                    this.referenceObject = result

                    return $.when(
                        this.setBasicParameters(),
                        this.setDataTypeInGroupOptions()
                    )
                }
            })
            .always(() => {
                this.$scope.options.isDataLoaded = true
            })
    }

    private onClear(): void {
        this.$scope.popupTitle = TypeHelper.emptyString
        this.$scope.showTabs = false

        this.referenceObject = null
        this.$scope.detailsParametersOptions = null

        this.$scope.dataTypeInGroupGridOptions = null
        this.$scope.dataTypesInGroupGridEditOptions = null
    }

    private onClose(): void {
        this.hidePopup()
    }

    private onConfirmDelete(): void {
        this.dataTypeGroupService
            .deleteDataTypeGroup(this.referenceObject.idDataTypeGroup)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
                this.hidePopup()
            })
            .fail((error: any) => {
                LogHelper.error(DataTypeGroupService.LOG_PREFIX, error)
            })
    }

    private onDelete(): void {
        this.confirmationPopup.show()
    }

    private onDataTypeInGroupSubmit(inGrid: any[]): JQueryPromise<boolean> {
        const deferred: JQueryDeferred<boolean> = $.Deferred<boolean>()

        this.referenceObject.currentDataTypesInGroup = _.map(inGrid, (item: any) => {
            const dataTypeInGroup: OpDataTypeInGroup = new OpDataTypeInGroup()
            dataTypeInGroup.idDataTypeGroup = this.referenceObject.idDataTypeGroup

            if (item.isRemoved == true) {
                dataTypeInGroup.opState = Enums.OpChangeState.Delete
            } else if (item.isNew == true) {
                dataTypeInGroup.opState = Enums.OpChangeState.New
            } else if (item.isEdited == true) {
                dataTypeInGroup.opState = Enums.OpChangeState.Modified
            } else {
                dataTypeInGroup.opState = Enums.OpChangeState.Loaded
            }

            dataTypeInGroup.descr = item[this.dataTypeGroupService.customDescrObject] != null ? BackwardCompatibilityHelper.DescrModelToOpDescr(item[this.dataTypeGroupService.customDescrObject]) : null
            dataTypeInGroup.idDataType = item[this.dataTypeGroupService.idDataTypeColumnName]
            dataTypeInGroup.orderNBR = item[this.dataTypeGroupService.orderNbrColumnName]

            if (dataTypeInGroup.descr != null) {
                if (dataTypeInGroup.descr.idDescr == null) {
                    dataTypeInGroup.descr.idDescr = 0
                }

                if (dataTypeInGroup.idDescr == null) {
                    dataTypeInGroup.idDescr = 0
                }

                if (_.size(dataTypeInGroup.descr.allLanguagesDescription) > 0) {
                    _.forEach(dataTypeInGroup.descr.allLanguagesDescription, (descr: OpDescr) => descr.idDescr = dataTypeInGroup.idDescr)
                }
            }

            return dataTypeInGroup
        })

        this.dataTypeGroupService
            .saveDataTypeGroup(this.referenceObject)
            .then((savedReferenceObject: OpDataTypeGroup) => {
                this.onRefresh(savedReferenceObject)
                deferred.resolve(true)
            })
            .fail((error: any) => {
                deferred.reject()
            })

        return deferred.promise();
    }

    // #endregion

    // #region Setup

    public getAccordions(): DetailsAccordion[] {
        const accordions: DetailsAccordion[] = []

        const hasParametersPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DataTypeGroupParameters)
        const hasInGroupPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DataTypeInGroupParameters)

        if (hasParametersPermission) {
            const sections: DetailsAccordionSection[] = []

            sections.push({
                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DataTypeGroupParameters),

                name: this.$scope.DATA_TYPE_GROUP_PARAMS_ACCORDION_NAME,
                showInTab: this.$scope.DATA_TYPE_GROUP_COMMON_TAB_NAME,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Parameters),

                showStatus: false,
                visible: true,

                editMethod: () => {
                    this.dataTypeGroupService.openEdit(this.referenceObject.idDataTypeGroup)
                }
            })

            const accordion: DetailsAccordion = new DetailsAccordion(
                this.$scope,
                this.$timeout,
                this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.DataTypeGroupAccordionSettings)),
                0,
                sections,
                true
            )

            accordion.needRefresh = () => {
                this.refreshDetails()
            }

            accordions.push(accordion)
        }

        if (hasInGroupPermission) {
            const sections: DetailsAccordionSection[] = []

            sections.push({
                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DataTypeInGroupParameters),

                name: this.$scope.DATA_TYPE_IN_GROUP_PARAMS_ACCORDION_NAME,
                showInTab: this.$scope.DATA_TYPE_GROUP_COMMON_TAB_NAME,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DataType),

                showStatus: true,
                visible: true,

                editMethod: () => {
                    this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.DATA_TYPE_IN_GROP_EDIT_POPUP_ID, 'dataTypeInGroup')
                },
                status: () => {
                    return `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Records)}: ${_.size(this.dataTypesInGroup)}`
                }
            })

            const accordion: DetailsAccordion = new DetailsAccordion(this.$scope, this.$timeout, this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.DataTypeGroupAccordionSettings)), 1, sections)

            accordion.needRefresh = () => {
                this.refreshDetails()
            }

            accordions.push(accordion)
        }

        return accordions
    }

    public getTabs(): any[] {
        const tabs: { template: string, name: string }[] = []

        const hasGeneralTabPermission: boolean = !this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DataTypeGroupParameters)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.DATA_TYPE_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DataTypeInGroupParameters)

        if (hasGeneralTabPermission) {
            tabs.push({
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),
                name: this.$scope.DATA_TYPE_GROUP_COMMON_TAB_NAME
            })
        }

        return tabs
    }

    private refreshDetails(): void {

    }

    private setLocalizationText(): void {
        this.$scope.ConfigurationText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Configuration)
        this.$scope.NoSchemaText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoSchema)
    }

    private setBasicParameters(): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()
        this.$scope.detailsParametersOptions = null

        this.dataTypeGroupService
            .getBasicParametersDataTypeGroup(this.referenceObject)
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.$scope.detailsParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: this.referenceType,
                    referenceObject: this.referenceObject,
                    useDynamicValues: true,
                    onDataLoaded: () => {
                        def.resolve()
                    }
                }
            })
            .catch(() => {
                def.reject()
            })

        if (this.isAccordionHidden(this.$scope.DATA_TYPE_GROUP_PARAMS_ACCORDION_NAME)) {
            def.resolve()
        }

        return def.promise()
    }

    private setDataTypeInGroupOptions(): void {
        this.$scope.isDataTypeInGridLoading = true
        this.$scope.dataTypeInGroupGridOptions = null

        this.dataTypesInGroup = this.referenceObject.currentDataTypesInGroup

        this.dataTypeGroupService
            .getDataTypesInGroupGridColumns()
            .then((columns: ColumnModel[]) => {
                this.$scope.dataTypeInGroupGridOptions = {
                    name: this.$scope.DATA_TYPE_IN_GROUP_GRID_NAME,
                    idReferenceType: Enums.ReferenceType.IdDataTypeInGroup,
                    type: GridTypes.NO_SEARCH_BAR_SMALL,
                    buttonsOptions: {
                        enabled: false,
                    },
                    addCustomFilters: true,
                    dataSource: this.dataTypesInGroup,
                    columnsDictionary: columns,
                    allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DataTypeInGroupParameters),
                    onInitialized: (e: any, dataTypesInGroupGrid: GridController<OpDataTypeInGroup>) => {
                        this.dataTypesInGroupGrid = dataTypesInGroupGrid
                        this.$scope.isDataTypeInGridLoading = false
                        this.initializeDataTypesInGroupGridEdit()
                    },
                    dataSourceParser: (item: OpDataTypeInGroup) => {
                        return this.getDataTypeInGroupDataSourceParser(item)
                    },
                }
            })
    }

    private getDataTypeInGroupDataSourceParser(item: OpDataTypeInGroup): { sourceObject?: OpDataTypeInGroup, additionalFields?: { key: string, value: any }[] } {
        const result: {
            sourceObject?: OpDataTypeInGroup
            additionalFields?: { key: string, value: any }[]
        } = {}

        result.sourceObject = item
        result.additionalFields = (item == null)
            ? []
            : [{
                key: 'id',
                value: item.idDataType
            }, {
                key: 'name',
                value: item.name
            }, {
                key: this.dataTypeGroupService.idDataTypeColumnName,
                value: item.idDataType
            }, {
                key: this.dataTypeGroupService.nameDataTypeColumnName,
                value: (item.dataType != null) ? item.dataType.name : ''
            },
            {
                key: this.dataTypeGroupService.descrDataTypeColumnName,
                value: (item.dataType != null && item.dataType.descr != null) ? item.dataType.toString() : ''
            },
            {
                key: this.dataTypeGroupService.orderNbrColumnName,
                value: item.orderNBR
            },
            {
                key: this.dataTypeGroupService.customDescrColumnName,
                value: (item.descr != null) ? item.descr.toString() : ''
            }, {
                key: this.dataTypeGroupService.customDescrObject,
                value: item.descr
            }]

        return result
    }

    private initializeDataTypesInGroupGridEdit(): void {
        $.when(
            this.dataTypeGroupService
                .getDataTypesInGroupGridColumns(true),
            this.dataTypeGroupService
                .getDataTypesGridColumns()
        )
            .then((columns: ColumnModel[], dtColumns: ColumnModel[]) => {
                this.setDataTypesInGroupGridEdit(columns, dtColumns)
            })
    }

    private setDataTypesInGroupGridEdit(columns: ColumnModel[], dtColumns: ColumnModel[]): void {
        this.$scope.dataTypesInGroupGridEditOptions = null

        _.forEach(columns, (column: ColumnModel) => {
            if (column.name === this.dataTypeGroupService.customDescrColumnName) {
                column.cellTemplate = (element: JQuery<HTMLElement>, itemData: any) => {
                    this.$scope.currentDescription = itemData.row.data[this.dataTypeGroupService.customDescrObject]
                    this.$scope.newCustomDescr = new OpDescr()

                    if (this.$scope.currentDescription != null) {
                        if (_.size(this.$scope.currentDescription.allLanguagesDescription) === 0) {
                            const desr: OpDescr = new OpDescr()
                            desr.copy(this.$scope.currentDescription)
                            this.$scope.currentDescription.allLanguagesDescription.push(desr)
                        }
                    }

                    this.$scope.onCustomDescrChanged = (elementId: number, propertyName: string, descr: DescrModel): void => {
                        itemData.data[this.dataTypeGroupService.customDescrObject] = descr
                        itemData.data.isEdited = true
                        itemData.component.repaintRows([itemData.rowIndex])
                    }

                    const template: string = '<select-add-descr current="' + (this.$scope.currentDescription != null ? 'currentDescription' : 'newCustomDescr') + '" element-id="' + itemData.row.data[this.dataTypeGroupService.idDataTypeColumnName] + '" descriptions="" property-name="descr" type="' + DescrType.ItemType + '" callback="::onCustomDescrChanged"></select-add-descr>'
                    const compiledTemplate: JQuery<HTMLElement> = this.$compile(template)(this.$scope)
                    element.css('padding', '0')
                    element.append(compiledTemplate)
                }
            }
        })

        this.dataTypesInGroupGrid
            .dxGrid
            .getDataSource()
            .store()
            .load()
            .done((items: any[]) => {
                this.userSession
                    .getDataProvider()
                    .System
                    .getDictionaries([Enums.ReferenceType.IdDataType])
                    .then((dict: Dictionary<Dictionary<IReferenceType>>) => {
                        const dataTypesDict: Dictionary<IReferenceType> = dict.tryGetValue(Enums.ReferenceType.IdDataType)

                        let dataTypes: OpDataType[] = []

                        if (dataTypesDict != null) {
                            dataTypes = <OpDataType[]>dataTypesDict.values()
                        }

                        this.$scope.dataTypesInGroupGridEditOptions = {
                            columns: columns,
                            id: this.referenceObjectId,
                            items: items,
                            name: this.DATA_TYPE_IN_GROP_GRID_EDIT_NAME,
                            popupId: this.DATA_TYPE_IN_GROP_EDIT_POPUP_ID,
                            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DataType),

                            allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DataTypeInGroupParameters),
                            allowDublicatedRow: false,

                            popoverColumns: dtColumns,
                            data: dataTypes,
                            dataSourceParser: (item: OpDataType): { sourceObject?: OpDataType, additionalFields?: { key: string, value: any }[] } => {
                                const result: {
                                    sourceObject?: OpDataType
                                    additionalFields?: { key: string, value: any }[]
                                } = {}

                                result.sourceObject = item
                                result.additionalFields = (item == null)
                                    ? []
                                    : [{
                                        key: 'id',
                                        value: item.idDataType
                                    }, {
                                        key: 'name',
                                        value: item.name
                                    }, {
                                        key: this.dataTypeGroupService.idDataTypeColumnName,
                                        value: item.idDataType
                                    }, {
                                        key: this.dataTypeGroupService.nameDataTypeColumnName,
                                        value: item.name
                                    },
                                    {
                                        key: this.dataTypeGroupService.descrDataTypeColumnName,
                                        value: (item.descr != null) ? item.toString() : ''
                                    }]

                                return result
                            },

                            onApply: (added: any[], removed: any[], inGrid: any[]) => {
                                return this.onDataTypeInGroupSubmit(inGrid)
                            }
                        }
                    })
            })
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => this.onOpen(args[3])
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            () => this.onClose()
        )

        this.$scope.$on(
            EventsNames.CLOSE_CREATE_EDIT_POPUP,
            (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0])
        )
    }

    private setOptions(): void {
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,

            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),

            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_DEL) ? Activity[Activity.LOCATION_DEL] : null,

            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

            deleteMethod: () => { this.onDelete() },
            getAccordionDataMethod: () => { return this.getAccordionData() },
            getAccordionSelectionMethod: () => { return this.getAccordionSelection() },
            updateAccordionMethod: (names: any[]) => { this.updateAccordions(names) },
            refreshButton: () => { this.onRefresh() }
        }
    }

    private setTemplateConsts(): void {
        this.$scope.NO_ACTIVE_ACCORDIONS_NAME = this.NO_ACTIVE_ACCORDIONS_NAME
        this.$scope.DATA_TYPE_GROUP_COMMON_TAB_NAME = 'DATA_TYPE_GROUP_COMMON_TAB_NAME'
        this.$scope.DATA_TYPE_GROUP_PARAMS_ACCORDION_NAME = 'DATA_TYPE_GROUP_PARAMS_ACCORDION_NAME'
        this.$scope.DATA_TYPE_IN_GROUP_PARAMS_ACCORDION_NAME = 'DATA_TYPE_IN_GROUP_PARAMS_ACCORDION_NAME'
    }

    // #endregion

    //#region IMRConfirmationPopup

    private setConfirmationPopup(): void {
        this.$scope.confirmationPopupOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
            content: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName),

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            },

            onConfirmed: () => {
                this.onConfirmDelete()
            }
        }
    }

    // #region Backward Compatibility - DO NOT USE, DELETE IN FUTURE

    public resetData(): void { this.onClear() }
    public loadData(id: number, objects: any[]): void { this.onOpen(null) }
    public updateData(result: any): void { this.onRefresh(result) }

    // #endregion
}
